import { useEffect, useState } from "react";
import { useSettings } from "@/lib/useSettings";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save, ShieldAlert } from "lucide-react";

export default function SecuritySettings() {
  const { data, save } = useSettings();
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);
  if (!f) return <div className="text-slate-400">Lädt…</div>;

  return (
    <div className="max-w-xl">
      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4">
        <h2 className="font-display text-lg font-bold text-slate-800">Automatischer Logout</h2>
        <p className="text-sm text-slate-500">Sicherheitseinstellung für die Nutzung des Redaktionssystems.</p>
        <div>
          <Label>Logout nach Inaktivität (Minuten)</Label>
          <Input type="number" min={1} value={f.auto_logout_minutes} onChange={(e) => setF({ ...f, auto_logout_minutes: Number(e.target.value) })} className="mt-1 w-32" data-testid="auto-logout-minutes" />
        </div>
        <div className="flex items-start gap-2 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3">
          <ShieldAlert size={16} className="mt-0.5 shrink-0" />
          Bei Inaktivität (keine Maus-/Tastaturaktionen) wird der Benutzer nach der angegebenen Zeit automatisch abgemeldet.
        </div>
        <Button onClick={() => save({ auto_logout_minutes: Number(f.auto_logout_minutes) || 30 })} className="bg-[#0B132B] hover:bg-[#1C2541]"><Save size={16} className="mr-1.5" /> Speichern</Button>
      </div>
    </div>
  );
}
